import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';

const logoUrl = 'https://cdn.shopify.com/s/files/1/0704/6378/2946/files/logo.png?v=1730407337';

const styles = StyleSheet.create({
    page: {
        fontSize: 10,
        fontFamily: 'Helvetica',
        padding: 40,
        backgroundColor: '#ffffff',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'start',
        marginBottom: 20,
    },
    logo: {
        width: 120,
        height: 25,
    },
    companyName: {
        fontSize: 24,
        color: '#f88a3d',
        fontWeight: 'bold',
        marginLeft: 10,
    },
    invoiceInfoContainer: {
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    invoiceTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        paddingBottom: '5px'
    },
    invoiceInfoText: {
        fontSize: 10,
        color: '#555555',
        marginBottom: 3,
        paddingBottom: '2px'
    },
    section: {
        marginVertical: 12,
    },
    billToTitle: {
        fontWeight: 'bold',
        fontSize: 10,
        marginBottom: 4,
    },
    billToText: {
        fontSize: 10,
        color: '#333333',
        paddingBottom: '5px'
    },
    itemsTable: {
        marginTop: 10,
        borderWidth: 0,
        borderColor: '#e0e0e0',
    },
    tableHeader: {
        borderTopRightRadius: '7px',
        borderTopLeftRadius: '7px',
        flexDirection: 'row',
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
        padding: 8,
        borderBottomWidth: 1,
        borderColor: '#e0e0e0',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#e0e0e0',
    },
    tableCell: {
        padding: 8,
        fontSize: 10,
        flexGrow: 1,
        textAlign: 'center',
    },
    itemDescription: {
        width: '40%',
        textAlign: 'left',
        paddingLeft: 8,
    },
    amountSection: {
        marginTop: 20,
        alignItems: 'flex-end',
    },
    amountRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '50%',
        marginBottom: 4,
    },
    amountText: {
        fontSize: 10,
        textAlign: 'right',
    },
    totalText: {
        fontWeight: 'bold',
    },
    footer: {
        marginTop: 30,
        fontSize: 10,
        textAlign: 'center',
        color: '#888888',
    },
});

const InvoicePDF = ({ invoiceData }) => (
    <Document>
        <Page style={styles.page}>
            {/* Header */}
            <View style={styles.header}>
                <View style={{ flexDirection: 'row', alignItems: 'start' }}>
                    <Image style={styles.logo} src={logoUrl} />
                </View>

                {/* Invoice Information - Right Aligned */}
                <View style={styles.invoiceInfoContainer}>
                    <Text style={styles.invoiceTitle}>Invoice #{invoiceData.invoiceNumber}</Text>
                    <Text style={styles.invoiceInfoText}>Date: {invoiceData.date}</Text>
                    <Text style={styles.invoiceInfoText}>Due Date: {invoiceData.dueDate}</Text>
                    <Text style={styles.invoiceInfoText}>{invoiceData.companyInfo.address}</Text>
                </View>
            </View>

            {/* Bill To Section */}
            <View style={styles.section}>
                <Text style={styles.billToTitle}>Bill to:</Text>
                <Text style={styles.billToText}>{invoiceData.billTo.name}</Text>
                <Text style={styles.billToText}>{invoiceData.billTo.address}</Text>
            </View>

            {/* Items Table */}
            <View style={styles.itemsTable}>
                {/* Table Header */}
                <View style={styles.tableHeader}>
                    <Text style={[styles.tableCell, styles.itemDescription]}>ITEM</Text>
                    <Text style={styles.tableCell}>QTY</Text>
                    <Text style={styles.tableCell}>RATE</Text>
                    <Text style={styles.tableCell}>AMOUNT</Text>
                </View>
                {/* Table Rows */}
                {invoiceData.items.map((item, index) => (
                    <View key={index} style={styles.tableRow}>
                        <Text style={[styles.tableCell, styles.itemDescription]}>{item.description}</Text>
                        <Text style={styles.tableCell}>{item.qty}</Text>
                        <Text style={styles.tableCell}>${item.rate}</Text>
                        <Text style={styles.tableCell}>${item.amount}</Text>
                    </View>
                ))}
            </View>

            {/* Amount Section */}
            <View style={styles.amountSection}>
                <View style={styles.amountRow}>
                    <Text style={styles.amountText}>Subtotal:</Text>
                    <Text style={styles.amountText}>${invoiceData.subtotal}</Text>
                </View>
                <View style={styles.amountRow}>
                    <Text style={styles.amountText}>Tax:</Text>
                    <Text style={styles.amountText}>${invoiceData.tax}</Text>
                </View>
                <View style={styles.amountRow}>
                    <Text style={[styles.amountText, styles.totalText]}>Total:</Text>
                    <Text style={[styles.amountText, styles.totalText]}>${invoiceData.total}</Text>
                </View>
                <View style={styles.amountRow}>
                    <Text style={styles.amountText}>Amount Paid:</Text>
                    <Text style={styles.amountText}>${invoiceData.amountPaid}</Text>
                </View>
                <View style={styles.amountRow}>
                    <Text style={[styles.amountText, styles.totalText]}>Due Balance:</Text>
                    <Text style={[styles.amountText, styles.totalText]}>${invoiceData.dueBalance}</Text>
                </View>
            </View>



            {/* Footer */}
            <View style={styles.footer}>
                <Text>Thank you!</Text>
                <Text>If you have any questions concerning this invoice, use the following contact information:</Text>
                <Text>masjidhub.com | +92 324 1234567</Text>
            </View>
        </Page>
    </Document>
);

export default InvoicePDF;
